import React from 'react';
import { Box, Divider, List, ListItem, ListItemText, Typography } from '@mui/material';

const renderProductItems = (productItems) => {
    return (
        <List dense>
            {productItems.map((item, index) => (
                <ListItem key={index} sx={{ pl: 4 }}>
                    <ListItemText
                        primary={
                            <>
                                <strong>{item.name}</strong> {item.tempId && <Typography component="span" variant="caption" sx={{ fontWeight: 'bold'}} color="primary">[NEW]</Typography>}
                            </>
                        }
                        secondary={(
                            <>
                                <Typography component="span" variant="body2">Description: {item.description}</Typography><br />
                                <Typography component="span" variant="body2">Business Code: {item.businessCode}</Typography><br />
                                <Typography component="span" variant="body2">Source File: {item.sourceFileName || "Not provided"}</Typography>
                            </>
                        )}
                    />
                </ListItem>
            ))}
        </List>
    );
}

const CreateProductReview = ({ activeForm }) => {
    return (
        <Box sx={{ p: 2 }}>
            <Typography variant="h5" gutterBottom>Basic Details</Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" gutterBottom><strong>Name:</strong> {activeForm?.name}</Typography>
            <Typography variant="body1" gutterBottom><strong>Description:</strong> {activeForm?.description}</Typography>
            <Typography variant="body1" gutterBottom><strong>Business Code:</strong> {activeForm?.businessCode}</Typography>
            <Typography variant="body1" gutterBottom><strong>Source File Name:</strong> {activeForm?.sourceFileName || "Not provided"}</Typography>
            <Typography variant="h5" gutterBottom sx={{ mt: 3 }}>Categories</Typography>
            <Divider sx={{ mb: 2 }} />
            {activeForm?.categories && activeForm?.categories?.map((category, index) => (
                <Box key={category.id || index} sx={{ mb: 3 }}>
                    <Typography variant="subtitle1">
                        <strong>Category Name: </strong>
                        {category?.name}
                        {!category.id && <Typography component="span" variant="caption" sx={{ fontWeight: 'bold'}} color="primary"> [NEW]</Typography>}
                    </Typography>
                    <Typography variant="subtitle2" sx={{ pl: 2, mb: 1 }}>Allowed Items:</Typography>
                    {renderProductItems(category?.productItems)}
                    {index < (activeForm?.categories?.length - 1) && <Divider sx={{ mt: 2 }} />}
                </Box>
            ))}
        </Box>
    );
}

export default CreateProductReview;